<template>
  <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h3 class="title">系统登录</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="ruleForm2.UserName" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="ruleForm2.PassWord" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
      <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
    </el-form-item>
  </el-form>
</template>

<script>
  import { requestLogin } from '../api/api'
  let Base64 = require('js-base64').Base64
  let qs = require('qs')
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        logining: false,
        ruleForm2: {
          UserName: '',
          PassWord: ''
        },
        rules2: {
          UserName: [
            { required: true, message: '请输入账号', trigger: 'blur' }
            //{ validator: validaePass }
          ],
          PassWord: [
            { required: true, message: '请输入密码', trigger: 'blur' }
            //{ validator: validaePass2 }
          ]
        },
        checked: true
      }
    },
    methods: {
      handleReset2 () {
        this.$refs.ruleForm2.resetFields()
      },
      handleSubmit2 (ev) {
        var _this = this
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            //_this.$router.replace('/table');
            this.logining = true
            //NProgress.start();
            var loginParams = qs.stringify({ UserName: this.ruleForm2.UserName, PassWord: this.ruleForm2.PassWord})
            requestLogin(loginParams).then(res => {
              this.logining = false
              if (res.data.Ack) {
                window.localStorage.Token = res.data.Create.Token
                this.$ajax.defaults.headers.common['Authorization'] = 'Bearer ' + window.localStorage.Token
                let user = Base64.decode(res.data.Create.Token.split('.')[1])
                localStorage.setItem('user', JSON.stringify(JSON.parse(user).Private))
                this.$router.push('/')
                // 存储打印信息到本地
                window.localStorage.printInfo = JSON.stringify(res.data.Print)
              } else {
                this.$message({
                  message: res.data.Message,
                  type: 'error'
                })
              }
              this.$router.push({ path: '/stock' })
              // }
            });
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?58dc847b